// @ts-ignore: No declarations available
import logdown from 'logdown';
// @ts-ignore: No declarations available
import { Maybe } from 'monet';
import React from 'react';
// @ts-ignore
import EllipsisText from 'react-ellipsis-text';
import { connect } from 'react-redux';
// @ts-ignore: No declarations available
import { returntypeof } from 'react-redux-typescript';
import { RouteProps, RouterProps } from 'react-router';
import { ModalFooter, ModalHeader, ModalBody, Button, Badge, Spinner } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import { State } from '../../reducers';
import { DraggableModal } from '../utils';

import AlertNocInCommandRequest from './AlertNocInCommandRequest';
import { sendNocInCommandRequest, updateNocInCommandRequest, closeAlertNocInCommandRequest, setSelectedAlert } from './data/alerts';

const logger = logdown('component:AlertNocInCommandRequestModal');

class Component extends React.Component<Props, unknown> {
  reset() {
    // this.props.updateAlertNotificationListingFilter(Maybe.none(), 1, this.props.alertsListing.sizePerPage);
    // this.props.updateAlertNotificationListingSort(Maybe.none());
    // this.props.fetchAlertNotifications(
    //   this.props.alertNotificationsListing.alert.some(),
    //   Maybe.none(),
    //   Maybe.none(),
    //   1,
    //   this.props.alertNotificationsListing.sizePerPage,
    // );
  }
  public render() {
    return (
      <DraggableModal
        id="noc-incommand-request-modal"
        data-testid="noc-incommand-request-modal"
        size="lg"
        // style={{ maxWidth: '1600px', width: '80%' }}
        isOpen={this.props.nocInCommandRequestDialog.isOpen}
        toggle={this.cancel.bind(this)}
        onUnmountWhileOpen={this.cancel.bind(this)}
      >
        <ModalHeader data-testid="noc-incommand-request-modal-header" toggle={this.cancel.bind(this)}>
          <EllipsisText
            className="noc-incommand-request-header"
            text={`NOC Alert Request: ${this.props.nocInCommandRequestDialog.alert.map((a: any) => a.source).getOrElse('N/A')}`}
            length={75}
          />
        </ModalHeader>
        <ModalBody>
          <AlertNocInCommandRequest {...this.props} />
        </ModalBody>
        <ModalFooter>
          <Button
            className="noc-incommand-request-send-button"
            data-testid="noc-incommand-request-modal-send-button"
            color="primary"
            onClick={this.send.bind(this)}
            disabled={this.props.nocInCommandRequestDialog.progressState.exists((p) => p.isInProgress)}
          >
            <Spinner size="sm" hidden={!this.props.nocInCommandRequestDialog.progressState.exists((p) => p.isInProgress)} /> Create
          </Button>
          <Button
            className="noc-incommand-request-cancel-button"
            data-testid="noc-incommand-request-modal-cancel-button"
            color="secondary"
            onClick={this.cancel.bind(this)}
            disabled={this.props.nocInCommandRequestDialog.progressState.exists((p) => p.isInProgress)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </DraggableModal>
    );
  }

  protected send(e: any) {
    e.preventDefault();
    this.props.sendNocInCommandRequest();
  }

  protected cancel(e?: any) {
    e?.preventDefault();
    // if (this.props.nocInCommandRequestSending.workLogs.isSome()) {
    //   return this.props.closeAlertNocInCommandRequest();
    // }
    this.props.setSelectedAlert('');
    this.props.closeAlertNocInCommandRequest();
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      sendNocInCommandRequest,
      updateNocInCommandRequest,
      closeAlertNocInCommandRequest,
      setSelectedAlert,
    },
    dispatch,
  );

const mapStateToProps = (state: State) => ({
  user: state.user,
  sitesListing: state.sitesListing,
  notificationGroupsListing: state.notificationGroupsListing,
  nocInCommandRequestDialog: state.nocInCommandRequestDialog,
  companiesListing: state.companiesListing,
  colleaguesListing: state.colleaguesListing,
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps & RouteProps & RouterProps;

// @ts-ignore
export default connect<typeof stateProps, typeof dispatchProps, any>(mapStateToProps, mapDispatchToProps)(Component);
